import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { GetOrgWaTemplatesRegisterApiArg } from '@/__generated/es-api'
import { ERROR_REGISTER_WA_TEMPLATE_SERVER } from '@/app/module/content/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useRegisterWaTemplate = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [register, res] = esApi.endpoints.getOrgWaTemplatesRegister.useMutation()

  const registerTemplate = useCallback(
    async (id: number, body: GetOrgWaTemplatesRegisterApiArg['body']) => {
      try {
        await register({ orgId: orgId.toString(), id: id.toString(), body }).unwrap()
        return true
      } catch (error) {
        dispatch(
          createNotification({
            'register-wa-template-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_REGISTER_WA_TEMPLATE_SERVER),
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, register],
  )

  return [registerTemplate, res] as const
}
